import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { MixingEvent } from 'projects/commons/src/lib/types/mixing'

@Component({
  standalone: true,
  selector: 'cyc-mixing-status',
  templateUrl: './mixing-status.component.html',
  styleUrls: ['./mixing-status.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MixingStatusComponent {
  @Input() mixingEvent: MixingEvent
}
